import MembersProfileSection from "./components/MembersProfileSection";
import { useState } from "react";
import { IMessageJobMembersProfile } from "@endpoints/types/message.type";
import ChatSection from "./components/ChatSection";

const MessagePage = () => {
  const [selectedContact, setSelectedContact] =
    useState<IMessageJobMembersProfile | null>(null);

  return (
    <div className="flex flex-1 rounded-md bg-white min-h-0 w-full">
      <MembersProfileSection
        selectedContact={selectedContact}
        setSelectedContact={setSelectedContact}
      />
      <ChatSection selectedContact={selectedContact} />
    </div>
  );
};

export default MessagePage;
